import { type MetaFunction } from '@remix-run/node'
import adirondack from './adirondack.png'

export const meta: MetaFunction = () => [
	{ title: 'Adirondack Insurance Exchange' },
	{
		name: 'description',
		content: 'Adirondack Insurance Exchange',
	},
]
export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">
				Adirondack Insurance Exchange
			</h1>
			<section>
				<img
					src={adirondack}
					alt="Adirondack Insurance Exchange"
					className="w-64"
				/>

				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					As a company, Adirondack has successfully established itself as an
					industry leader in personal lines. Its package policies are one of the
					best in the market. The broad coverages available coupled with
					competitive pricing make for a very attractive offering. In addition
					to packages, Adirondack also offers homeowner's and automobile
					policies.
				</p>

				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://www.aie-ny.com"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.aie-ny.com (opens in a new tab)
					</a>
				</p>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Claims: 877-629-8003
					<br />
					Roadside Assistance: 800-668-1398
				</p>
			</section>
			<section>
				<h3>Home Office Address</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Adirondack Insurance Exchange
					<br />
					5630 University Parkway
					<br />
					Winston-Salem, NC 27105
				</p>
			</section>
		</main>
	)
}
